// extracted by mini-css-extract-plugin
export default {"formContainer":"SignUpForm_formContainer__R1gMI","checkboxContainer":"SignUpForm_checkboxContainer__yr3C7","terms":"SignUpForm_terms__JV009","errors":"SignUpForm_errors__HQDAH"};